import { CardContent } from '@mui/material';
import Box from '@mui/material/Box';
import CardHeader from '@mui/material/CardHeader';
import Grid from '@mui/material/Grid';
import React from 'react';
import { MyMLabel } from '../../ui-elements/MyMLabel';
import { MyMBlackLink } from '../../ui-elements/MyMLink';
import SalesLv1MetadataCard from './SalesLv1MetadataCard';

export const SalesLv1SalesProcessCard = ({ navigateSalesLv2, borderSolid, controlSettings, salesProcess }) => {
  const lblTitle = controlSettings.LabelList[`lblProcessCategoryTitle_${salesProcess.Process1MetadataId}`]
  const lblMessage = controlSettings.LabelList[`lblProcessCategoryMessage_${salesProcess.Process1MetadataId}`]
  return (
    <SalesLv1MetadataCard>
      <CardHeader
        className="py-1 w-100"
        sx={{
          '.MuiCardHeader-title': {
            textAlign: 'center',
            marginBottom: salesProcess.Process1MetadataId === 46 ? '19px' : 0,
          },
          '.MuiCardHeader-subheader': {
            fontSize: '1rem',
            color: 'black',
            marginTop: 2.5,
            minBlockSize: '100px',
          },
          borderBottom: borderSolid,
        }}
        title={lblTitle}
        subheader={lblMessage}
      />
      <CardContent className='py-1'>
        <Box className='mt-2'>
          <Grid container>
            {salesProcess.Process2HierarchyList.map((hierarchyList, hierarchyIndex) => {
              return (
                <Grid item xs={6} key={hierarchyIndex} className='pb-1'>
                  <MyMLabel className='fw-bolder' fontSize='1rem'>{hierarchyList.Process2Name}</MyMLabel>
                  <Grid container sx={{ display: 'flex', flexDirection: 'column' }}>
                    {hierarchyList.SalesProcessGroupList.map((process3, process3Index) => {
                      return (
                        <Grid item className='py-1' key={process3Index} >
                          <MyMBlackLink className='text-start' onClick={() => navigateSalesLv2(process3)}>{process3.Name}</MyMBlackLink>
                        </Grid>
                      )
                    })}
                  </Grid>
                </Grid>
              )
            })}
          </Grid>
        </Box>
      </CardContent>
    </SalesLv1MetadataCard>
  )
}

